/**
 * Wraps the existing PDP description block in a collapsible accordion
 * ("Descripción del producto" + chevron), collapsed by default. Reuses the
 * exact accordion markup/classes (.vpe-acc*) already styled and animated in
 * assets/volts-product-page.css — nothing new to style, no content is
 * changed or removed, only the presentation around it.
 *
 * Runs independently of assets/product-description-enhance.js (which may
 * run before or after this — both keep working either way, since this only
 * adds ancestors around the same description element, it never leaves the
 * .product-details subtree).
 */

function run() {
  // blocks/price.liquid also carries the shared `.rte` class (its
  // type_preset is "paragraph"), so it must be excluded explicitly —
  // otherwise this grabs the price block instead of the description.
  const scope = Array.from(document.querySelectorAll('.product-details .rte')).find(
    (el) => !el.closest('product-price')
  );
  if (!scope) return;

  const container = /** @type {HTMLElement} */ (scope.closest('.text-block') || scope);
  if (container.dataset.pdpAccordionDone) return;
  container.dataset.pdpAccordionDone = 'true';

  const bodyId = 'pdp-description-body';

  const item = document.createElement('div');
  item.className = 'vpe-acc__item pdp-desc-acc__item';

  const trigger = document.createElement('button');
  trigger.type = 'button';
  trigger.className = 'vpe-acc__trigger';
  trigger.setAttribute('aria-expanded', 'false');
  trigger.setAttribute('aria-controls', bodyId);
  trigger.innerHTML = `
    <span class="vpe-acc__trigger-text">Descripción del producto</span>
    <svg class="vpe-acc__chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>
  `;

  const body = document.createElement('div');
  body.className = 'vpe-acc__body';
  body.id = bodyId;
  body.setAttribute('role', 'region');

  const inner = document.createElement('div');
  inner.className = 'vpe-acc__inner';

  const content = document.createElement('div');
  content.className = 'vpe-acc__content';

  container.parentNode.insertBefore(item, container);
  content.appendChild(container);
  inner.appendChild(content);
  body.appendChild(inner);
  item.appendChild(trigger);
  item.appendChild(body);

  trigger.addEventListener('click', () => {
    const isOpen = item.classList.contains('is-open');
    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', run);
} else {
  run();
}
